import { j as e } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as r } from "react";
import { I as i } from "../../../../IconBase-CxZyIWw2.js";
const l = r((o, c) => /* @__PURE__ */ e.jsx(
  i,
  {
    ref: c,
    ...o,
    image: (a) => /* @__PURE__ */ e.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...a,
        children: /* @__PURE__ */ e.jsx(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M17.255 6.925C20.29 3.654 18.976.025 16.279 0a2.22 2.22 0 0 0-1.62.675A2.34 2.34 0 0 0 14 2.335c.009 1.065.712 1.77 1.417 2.478.575.578 1.153 1.157 1.357 1.935.057.22.33.339.48.177M16 13.481C15.88 4.847 9.182 1.836 5.368 5.584A4.52 4.52 0 0 0 4 8.76a4.32 4.32 0 0 0 1.296 3.144c1.437 1.413 3.366 1.371 5.302 1.33 1.58-.035 3.164-.07 4.49.685.376.214.918-.01.912-.437m0 5.038c.12 8.634 6.818 11.645 10.632 7.897A4.52 4.52 0 0 0 28 23.24a4.32 4.32 0 0 0-1.296-3.144c-1.437-1.413-3.366-1.371-5.302-1.33-1.58.035-3.164.07-4.49-.685-.375-.214-.918.01-.912.437m10.416-13.15c3.748 3.813.737 10.512-7.897 10.631-.426.006-.65-.537-.437-.912.755-1.326.72-2.91.686-4.49-.042-1.936-.084-3.865 1.329-5.302A4.32 4.32 0 0 1 23.24 4a4.52 4.52 0 0 1 3.175 1.368M15.72 31.998c-2.697-.024-4.012-3.653-.976-6.924.15-.162.424-.043.481.177.204.778.781 1.357 1.357 1.935.705.708 1.408 1.413 1.417 2.478a2.34 2.34 0 0 1-.66 1.66 2.22 2.22 0 0 1-1.62.675M6.925 14.746C3.654 11.71.025 13.024 0 15.721c-.005.588.22 1.174.675 1.62a2.34 2.34 0 0 0 1.66.659c1.065-.009 1.77-.712 2.478-1.417.578-.575 1.157-1.153 1.935-1.357.22-.057.339-.33.177-.48M32 16.28c-.025 2.697-3.654 4.012-6.925.976-.162-.15-.043-.424.177-.481.778-.204 1.357-.782 1.935-1.357.708-.705 1.413-1.408 2.478-1.417a2.34 2.34 0 0 1 1.66.66c.456.445.68 1.031.675 1.62M13.48 16c-8.634.12-11.645 6.818-7.897 10.632A4.52 4.52 0 0 0 8.76 28a4.32 4.32 0 0 0 3.144-1.296c1.413-1.437 1.371-3.366 1.33-5.302-.035-1.58-.07-3.164.685-4.49.214-.375-.01-.918-.437-.912",
            clipRule: "evenodd"
          }
        )
      }
    )
  }
));
l.displayName = "VeryOilyIcon";
export {
  l as VeryOilyIcon,
  l as default
};
//# sourceMappingURL=index.js.map
